import forIn from 'lodash/forIn';

export const createPathParams = <TParams extends string>(
  path: string,
  pathParamsObject: { [key in TParams]?: string | number }
): string => {
  let newPath = path;
  forIn(pathParamsObject, (value, key) => {
    const regExp = new RegExp(`{{${key}}}`, 'g');
    newPath = newPath.replace(regExp, value as string);
  });
  return newPath;
};
